<template>
  <div class="content">
    <div class="col-md-8 flex-container-top">
      <base-button
        type="primary"
        round
        icon
        class="top-button-back"
        @click="$router.push('list')"
      >
        <i class="fa fa-arrow-left"></i>
      </base-button>

      <h2 class="text-center">Add City</h2>
    </div>
    <div class="row">
      <div class="col-md-8">
        <card>
          <form onSubmit="return false;">
            <div class="row">
              <div class="mt-4 col-md-12">
                <base-input
                  type="text"
                  label="City Name*"
                  maxlength="50"
                  placeholder="Name"
                  v-model="name"
                >
                </base-input>
              </div>
            </div>

            <div class="row" style="padding: 30px"></div>

            <base-button
              native-type="submit"
              type="primary"
              value="Compares"
              class="btn-fill col-md-12"
              :disabled="loading"
              @click="addCity()"
              >Save</base-button
            >

            <div class="row" style="padding: 10px"></div>
          </form>
        </card>
      </div>

      <div class="col-md-4">
        <card class="card-user">
          <p class="card-text"></p>
          <div class="author">
            <div class="block block-one"></div>
            <div class="block block-two"></div>
            <div class="block block-three"></div>
            <div class="block block-four"></div>
            <div class="col-md-12 col-sm-12">
              <h4 class="card-title">City Image</h4>
              <image-upload
                :src="image"
                @change="onImageChange"
                select-text="Select Image"
              />
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="full-screen-loader" v-if="loading">
      <div class="sk-chase">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ImageUpload } from "src/components/index";

export default {
  components: {
    ImageUpload,
  },
  data() {
    return {
      name: "",
      image: null,
      loading: false,
      imageUploaded: false,
    };
  },
  methods: {
    async addCity() {
      if (!this.name) {
        this.$apiService.notify("Name is mandatory.");
        return;
      }
      if (!this.image) {
        this.$apiService.notify("Image is mandatory.");
        return;
      }

      this.loading = true;

      try {
        let imageUrl = this.image;
        if (this.imageUploaded) {
          imageUrl = await this.$apiService.uploadImage(this.image);
        }

        var Citydata = {
          name: this.name,
          imageUrl: imageUrl,
        };

        var update_eve = await this.$apiService.postCall(
          "city/addcity",
          Citydata
        );
        console.log(update_eve);
        this.$apiService.notify("City has been added.");
        this.$router.push("/city/list");
      } finally {
        this.loading = false;
      }
    },
    onImageChange(file) {
      this.image = file;
      this.imageUploaded = true;
    },
  },
};
</script>

<style>
.location {
  background: #27293d;
  border: 1px solid #2b3553;
  padding: 8px;
  font-size: 14px;
  border-radius: 5px;
  width: 100%;
  color: white;
}
form label {
  font-weight: 600;
}

.coordinate {
  background: #27293d;
  border: 1px solid #2b3553;
  padding: 5px;
  font-size: 14px;
  border-radius: 5px;
  color: white;
}
.radio-item input[type="radio"]:checked + label:after {
  border-radius: 11px;
  width: 12px;
  height: 12px;
  position: absolute;
  top: 9px;
  left: 19px;
  content: " ";
  display: block;
  background: #e14eca;
}
.radio-item {
  display: inline-block;
  position: relative;
  padding: 0 15px;
  margin: 10px 0 0;
}

.radio-item input[type="radio"] {
  display: none;
}
.radio-item label {
  color: white;
  font-weight: 600;
}
.radio-item label:before {
  content: " ";
  display: inline-block;
  position: relative;
  top: 5px;
  margin: 0 5px 0 0;
  width: 20px;
  height: 20px;
  border-radius: 11px;
  border: 2px solid white;
  background-color: transparent;
}
</style>
